<template>
  <TrustpilotWrapper
    :widget-id="TRUSTPILOT_MICRO_COMBO_WIDGET_ID"
    :show-widget="showWidget"
    :theme="theme"
    :trustpilot-height="TRUSTPILOT_MICRO_COMBO_WIDGET_HEIGHT"
  />
</template>

<script lang="ts">
import { TRUSTPILOT_MICRO_COMBO_WIDGET_HEIGHT } from '~~/constants/ui';
import { TRUSTPILOT_MICRO_COMBO_WIDGET_ID, TRUSTPILOT_THEMES } from '~~/constants/trustPilot';

export default defineComponent({
  name: 'TrustpilotMicroCombo',

  props: {
    showWidget: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String as PropType<ValueOf<typeof TRUSTPILOT_THEMES>>,
      default: TRUSTPILOT_THEMES.LIGHT,
    },
  },
  setup () {

    return {
      TRUSTPILOT_MICRO_COMBO_WIDGET_ID,
      TRUSTPILOT_MICRO_COMBO_WIDGET_HEIGHT,
    };
  
  },
});


</script>
